import {Component} from '@angular/core';
import {TranslocoDirective} from '@jsverse/transloco';

@Component({
  selector: 'app-demonstration-score-legend',
  imports: [TranslocoDirective],
  templateUrl: './demonstration-score-legend.component.html',
})
export class DemonstrationScoreLegendComponent {}
